<template>
  <div class="flex flex-col gap-4">  
    <h2>{{ $t("Simulation.NewTitle") }}</h2>            
    <v-text-field hide-details  :label="$t('Simulation.Libelle')" v-model="mig_libelle" />     
    <v-select v-if="modified.config" hide-details  :items="planModes" item-text="libelle" item-value="value" :label="$t('Simulation.PlanMode')"
        v-model="processing_mode"
      ></v-select>
  </div>
</template>
<script lang="ts">


import Vue from 'vue'
import Component from 'vue-class-component'
import { ISmartSimulation, getDefaultSmartSimulation } from '@/models/iris/smartMission/ISmartSimulation'
import {MissionGlobalType} from '@/enum/MissionGlobalType'
import { Watch } from 'vue-property-decorator'
import { SimulationMode } from '@/enum/SimulationMode'


  
@Component({
  name: 'SimulationNew', 
})
export default class SimulationNew extends Vue {      
    
  slugify = require('slugify')

  created() {               
    this.modified.ENS_ID = this.$store.myGetters.filterMission?.ensIds?.at(0) ?? this.$store.myGetters.userProfile.ensId
    this.modified.MIG_TYP = MissionGlobalType.SIMULATION       
    this.modified.config = getDefaultSmartSimulation()
    this.modified.MIG_LIBELLE = ""
  }
  
  get processing_mode(){
    return this.modified.config!.processing_mode
  }

  set processing_mode(value:string) {        
    if(value == SimulationMode.coverage) this.modified.MIG_TYP = MissionGlobalType.COVERAGE   
    else if(value == SimulationMode.simulator) this.modified.MIG_TYP = MissionGlobalType.SIMULATION    
    else if(value == SimulationMode.formation) this.modified.MIG_TYP = MissionGlobalType.FORMATION    
    this.modified.config!.processing_mode = value            
  }

 
  // BLF037 — seulement les types autorisés pour l'enseigne cible (RG-ACC-052).
  get planModes(){
    const allowed: MissionGlobalType[] = this.$store.myGetters.missionGlobalTypesFor(this.modified.ENS_ID)
    return [
      {libelle:this.$t('Simulation.Manual'),value:SimulationMode.simulator,typ:MissionGlobalType.SIMULATION},
      {libelle:this.$t('Simulation.Coverage'),value:SimulationMode.coverage,typ:MissionGlobalType.COVERAGE},
      {libelle:this.$t('Simulation.Formation'),value:SimulationMode.formation,typ:MissionGlobalType.FORMATION}
    ].filter(mode => allowed.includes(mode.typ))
  }
  
  get modified(){
    return this.$store.myGetters.modifiedAdmMissionGlobal
  }
    

  get mig_libelle(){
    return this.modified.MIG_LIBELLE!
  }

  set mig_libelle(value:string) {            
    this.$store.myActions.MISSIONGLOBAL_UPDATE_MODIFIED_ADM({
      MIG_LIBELLE:value,
      MIG_KEY:this.slugify(value ?? '',{lower:true,replacement:'_',strict:true}),
      MIG_JSON:JSON.stringify(this.modified.config)
    })
  }

}

</script> 
